/*
 * PendingForm Messages
 *
 * This contains all the text for the PendingForm component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  cancel: {
    id: 'app.common.cancel',
    defaultMessage: 'Cancel',
  },
  post: {
    id: 'app.components.PostEditor.post',
    defaultMessage: 'Post Message',
  },
  saveDraft: {
    id: 'app.components.PostEditor.saveDraft',
    defaultMessage: 'Save as Draft',
  },
  schedulePost: {
    id: 'app.components.PostEditor.schedulePost',
    defaultMessage: 'Schedule Sending',
  },
  scheduleHelp: {
    id: 'app.components.PostEditor.scheduleHelp',
    defaultMessage: 'Select the date on which you want to send the post',
  },
  sendOn: {
    id: 'app.components.PostEditor.sendOn',
    defaultMessage: 'Send ',
  },
  sendNow: {
    id: 'app.components.PostEditor.sendNow',
    defaultMessage: 'Send Now',
  },
  reschedule: {
    id: 'app.components.PostEditor.reschedule',
    defaultMessage: 'Change Send Date',
  },
  dropSchedule: {
    id: 'app.components.PostEditor.dropSchedule',
    defaultMessage: 'Remove Send Date',
  },
  delete: {
    id: 'app.components.PostEditor.delete',
    defaultMessage: 'Delete',
  },
  deleteItem: {
    id: 'app.components.PendingForm.deleteItem',
    defaultMessage: "Delete item ''{title}''?",
  },
  deleteUntitled: {
    id: 'app.components.PendingForm.deleteUntitled',
    defaultMessage: 'Delete item?',
  },
  save: {
    id: 'app.common.save',
    defaultMessage: 'Save',
  },
  remove: {
    id: 'app.common.delete',
    defaultMessage: 'Delete',
  },
  draftSaved: {
    id: 'app.components.PendingForm.draftSaved',
    defaultMessage: 'The draft item has been saved',
  },
  itemScheduled: {
    id: 'app.components.PendingForm.itemScheduled',
    defaultMessage: 'The item has been scheduled',
  },
  missingDate: {
    id: 'app.components.CommunityPosts.missingDate',
    defaultMessage: 'Scheduled date missing',
  },

});
